import { matchPath } from 'react-router-dom';

import { Polyglot } from 'components/translate';

import PAGE_TITLES from './constants';

export const getPageTitle = (pathname) => {
  const paths = Object.entries(PAGE_TITLES).find(([path]) => {
    return Boolean(matchPath(pathname, { path, exact: true }));
  });

  return Polyglot.t(paths?.[1]);
};
